import { Modal, List, ListItem, ListIcon, ModalContent, ModalOverlay, useOutsideClick, Flex, Image } from '@chakra-ui/react'
import React from 'react';
import { HashLink } from 'react-router-hash-link';
import style from './style.module.css';
import { BsArrowRightShort } from 'react-icons/bs';
import { Link } from "@chakra-ui/react";
import facebookImg from '../../img/facebook.svg';
import twitterImg from '../../img/twitter.svg';
import instagramImg from '../../img/instagram.svg';
import linkedinImg from '../../img/linkedin.svg';

function Nav() {
    const ref = React.useRef()
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    useOutsideClick({
        ref: ref,
        handler: () => setIsModalOpen(false)
    })

    return (
        <>
            <Modal
                size="lg"
                returnFocusOnClose={false}
                isCentered
                onClose={setIsModalOpen}
                isOpen={isModalOpen}
                motionPreset="slideInBottom"
            >
                <ModalOverlay backgroundColor="#211245a3" />
                <ModalContent top="-130px" className={style.nav_modal}>
                    {/* <ModalBody > */}
                    <Flex flexDirection="column" justifyContent="space-between" borderRadius="13px" background="radial-gradient(circle, rgba(104,56,219,1) 0%, rgba(56,30,119,1) 100%, rgba(54,29,114,1) 100%)" h="100%">
                        <List spacing={3}>
                            <HashLink to="#early-access-form">
                                <ListItem  height="50px"
                                            display="flex"
                                            marginTop="15px"
                                            marginLeft="15px"
                                            marginRight="15px"
                                            alignItems="center"
                                            borderRadius="13px"
                                            border="none"
                                            color="white" 
                                            _hover={{
                                                backgroundColor: 'white',
                                                color: "black"
                                            }}
                                    >
                                    <ListIcon as={BsArrowRightShort} fontSize="30px" color="white" />
                                    Create a free account
                                </ListItem>
                            </HashLink>
                        </List>

                        <Flex m="60px auto 10px auto" justifyContent="space-between" w="90%">
                            <Link href="https://facebook.com/swiftfinanceapp/"> <Image src={facebookImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                            <Link href="https://twitter.com/swiftfinanceapp"> <Image src={twitterImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                            <Link href="https://instagram.com/swiftfinanceapp"> <Image src={instagramImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                            <Link href="#"> <Image src={linkedinImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                        </Flex>
                    </Flex>
                    {/* </ModalBody> */}
                </ModalContent>
            </Modal>

            <button className={`${style.nav_button} ${isModalOpen && style.open_nav}`} onClick={() => setIsModalOpen(true)}>
                <div className={style.nav_stripe_1}></div>
                <div className={style.nav_stripe_2}></div>
                <div className={style.nav_stripe_3}></div>
            </button>

        </>
    )
}

export default Nav;
